import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { TreatmentProvidedAppointment, useTreatmentsProvidedAppointments } from "../../../api/useTreatmentsProvidedAppointments";
import { getLabelByServiceId, getPeriodicityLabel } from "./utils";
import { CalendarMonth as CalendarMonthIcon } from "@mui/icons-material/";
import { WarningBoxVisibilityList } from "../../../components/warnings/WarningBox";

type TreatmentProvidedAppointmentsWarningProps = {
	treatmentId: number;
	color: "warning" | "error";
};

const TreatmentProvidedAppointmentsWarning = ({ treatmentId, color }: TreatmentProvidedAppointmentsWarningProps) => {
	const { data, error } = useTreatmentsProvidedAppointments({ appointmentFulfillmentOnly: true, treatmentId });
	if (!data || error) return null;

	const treatment = data.find((item) => item?.id === treatmentId) as TreatmentProvidedAppointment | undefined;
	if (!treatment || !treatment.appointment_fulfillment) return null;

	const entries = Object.entries(treatment.appointment_fulfillment);
	const hasUnfulfilled = entries.some(([_, item]) => item.prescribed_quantity > item.booked_sessions);
	
	if (!hasUnfulfilled) return null;
	
	let isNonePeriodicity = false
	const mappedWarnings = (
		<Box sx={{ display: "flex", flex: 1, rowGap: 1, columnGap: 2, flexWrap: "inherit", justifyContent: "center" }}>
			{entries.map(([id, item]) => {
				const serviceName = getLabelByServiceId(Number(id));
				const sessions = `${item.booked_sessions}/${item.prescribed_quantity} (${
					getPeriodicityLabel(item.periodicity)?.label
				})`;
				isNonePeriodicity = item.periodicity === "not_applicable" ? true : false
				

				return (
					<React.Fragment key={id}>
						{item.booked_sessions !== item.prescribed_quantity && (
							<Chip
								sx={{ width: "fit-content", px: 1 }}
								label={`${serviceName} - ${sessions}`}
								color={color}
								size="small"
								variant="filled"
							/>
						)}
					</React.Fragment>
				);
			})}
		</Box>
	);
	if (isNonePeriodicity) return null
	return (
		<Tooltip title="Sessões por marcar">
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					flex: 1,
					justifyContent: "space-between",
					alignItems: "center",
					gap: 1,
					flexWrap: "inherit",
				}}
			>
				<CalendarMonthIcon color={color} />
				{mappedWarnings}
			</Box>
		</Tooltip>
	);
};

export const treatmentProvidedAppointmentsWarning = (treatmentId: number | null) => {
	const color = "error";
	if (!treatmentId) return {show: false, content: <></>, color:color, visibleTo:[]}

	const warning = TreatmentProvidedAppointmentsWarning({ treatmentId, color });
	const warningVisibleTo: WarningBoxVisibilityList = ["reception", "technician"]
	return { show: !!warning, content: warning, color: color, visibleTo: warningVisibleTo };
};